import React from 'react';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function DielineSection({ form }) {
  return (
    <div>
      <span className="label customization-heading">Dieline</span>
      <Form.Item
        label="Dieline Image"
        name="dieline_img"
        type="chooseFile"
        displayFile={form.getFieldValue('dieline_img')?.preview || form.getFieldValue('dieline_img') || null}
        small
        rules={[{ required: true, message: `Select die-line image` }]}>
        <Field />
      </Form.Item>
      <Form.Item label="Alt" type="text" name="dieline_image_alt" sm rules={[{ required: true, message: 'Enter alt' }]}>
        <Field />
      </Form.Item>
      <Form.Item
        label="Heading"
        type="text"
        name="dieline_heading"
        sm
        rules={[{ required: true, message: 'Enter heading' }]}>
        <Field />
      </Form.Item>
      <Form.Item
        label="Description"
        type="textarea"
        name="dieline_description"
        sm
        rules={[{ required: true, message: 'Enter material description' }]}>
        <Field />
      </Form.Item>
      <Form.Item
        label="Dieline File"
        name="dieline_file"
        type="chooseFile"
        accept={{ 'application/zip': ['.zip'] }}
        displayFile={form.getFieldValue('dieline_file')?.preview || form.getFieldValue('dieline_file') || null}
        small
        rules={[{ required: true, message: `Select die-line file` }]}>
        <Field />
      </Form.Item>
    </div>
  );
}

export default DielineSection;
